import { faker } from '@faker-js/faker'

export interface BenchmarkingItem {
    billDate: string
    entityId: number
    entityName: string
    usage: {
        current: number
        unitId: number
    }
    cost: {
        current: number
        currencyId: number
    }
    costPerUsage: {
        current: number
    }
}

export const generateBenchmarkingResponse = (): BenchmarkingItem[] => {
    // Create a list of entities (tags and facilities combined)
    const entities = [
        // Tags
        { id: 1977, name: 'Lower Campus' },
        { id: 1982, name: 'Product A' },
        { id: 1983, name: 'Product B' },
        { id: 1984, name: 'Pilot Testing' },
        { id: 1985, name: 'Manufacturing' },
        { id: 1986, name: 'Distribution' },
        { id: 1987, name: 'Office' },
        // Facilities
        { id: 127322, name: '100 Demo Road' },
        { id: 127323, name: '200 W Demo Ave' },
        { id: 127324, name: '300 Demo Road' },
        { id: 127325, name: '100 Industrial Way' },
        { id: 127326, name: '200 Industrial Way' },
        { id: 170000, name: '400 Demo Street' },
        { id: 170001, name: '500 Demo Street' },
        { id: 170002, name: '600 Demo Street' },
        { id: 170003, name: '700 Demo Street' },
        { id: 170004, name: '800 Demo Street' },
        { id: 170005, name: '900 Demo Street' },
        { id: 170006, name: '100 Park Drive' },
        { id: 170007, name: '200 Park Drive' },
        { id: 170008, name: '300 Park Drive' },
        { id: 170009, name: '400 Park Drive' },
        { id: 170010, name: '500 Park Drive' },
    ]

    // Generate dates for 12 months
    const dates = [
        '2024-02-01T00:00:00.000Z',
        '2024-03-01T00:00:00.000Z',
        '2024-04-01T00:00:00.000Z',
        '2024-05-01T00:00:00.000Z',
        '2024-06-01T00:00:00.000Z',
        '2024-07-01T00:00:00.000Z',
        '2024-08-01T00:00:00.000Z',
        '2024-09-01T00:00:00.000Z',
        '2024-10-01T00:00:00.000Z',
        '2024-11-01T00:00:00.000Z',
        '2024-12-01T00:00:00.000Z',
        '2025-01-01T00:00:00.000Z',
    ]

    const result: BenchmarkingItem[] = []

    // Create entries for each entity for each month
    entities.forEach((entity) => {
        dates.forEach((date) => {
            // Generate random usage and cost values
            const usage = faker.number.float({
                min: 1000,
                max: 500000,
                fractionDigits: 2,
            })

            const cost = faker.number.float({
                min: 1000,
                max: 80000,
                fractionDigits: 2,
            })

            const costPerUsage = parseFloat((cost / usage).toFixed(2))

            result.push({
                billDate: date,
                entityId: entity.id,
                entityName: entity.name,
                usage: {
                    current: usage,
                    unitId: 2,
                },
                cost: {
                    current: cost,
                    currencyId: 1,
                },
                costPerUsage: {
                    current: costPerUsage,
                },
            })
        })
    })

    return result
}
